import formConfig from './bedrock';

describe('bedrock form config', () => {
  it('is live', () => {
    expect(formConfig.live).toBe(true);
    expect(formConfig.approval).toBeUndefined();
  });

  it('asks for required user licences immediately before monthly budget', () => {
    const page = formConfig.sections[0].subsections
      .find(({ slug }) => slug === 'requirements')
      ?.pages.find(({ pageType }) => pageType === 'question');
    const questions = page?.pageType === 'question' ? page.questions : undefined;

    expect(questions).toBeDefined();
    const licenceIndex = questions?.findIndex(
      ({ name }) => name === 'number-of-user-licences',
    );
    const budgetIndex = questions?.findIndex(
      ({ name }) => name === 'estimated-monthly-budget',
    );

    expect(licenceIndex).toBeGreaterThanOrEqual(0);
    expect(budgetIndex).toBe((licenceIndex ?? -1) + 1);
    expect(questions?.[licenceIndex ?? -1]).toEqual(
      expect.objectContaining({
        questionType: 'textInputSmall',
        title: 'How many user licences do you require?',
        hint: 'If completing this form only for yourself, enter 1',
        rules: {
          required: true,
        },
        errorMessages: {
          required: 'This field is required',
        },
      }),
    );
    expect(questions?.[budgetIndex ?? -1]?.hint).toBe(
      'Enter the amount your team could commit each month, excluding VAT.  \n' +
        'This is an estimate and is not a commitment to spend.',
    );
  });
});
